var jade = require("D:\\Jenkins670\\workspace\\D_PIPELINE_release_661166.5.70.0\\JAVA\\ui\\group_ui\\node_modules\\jade\\lib\\runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (ctaLabel, ctaTarget, ctaUrl) {
buf.push("<div class=\"container-row\"><a href=\"" + (jade.escape((jade_interp = ctaUrl) == null ? '' : jade_interp)) + "\" target=\"" + (jade.escape((jade_interp = ctaTarget) == null ? '' : jade_interp)) + "\" class=\"cta-button\">" + (jade.escape((jade_interp = ctaLabel) == null ? '' : jade_interp)) + "</a></div>");}.call(this,"ctaLabel" in locals_for_with?locals_for_with.ctaLabel:typeof ctaLabel!=="undefined"?ctaLabel:undefined,"ctaTarget" in locals_for_with?locals_for_with.ctaTarget:typeof ctaTarget!=="undefined"?ctaTarget:undefined,"ctaUrl" in locals_for_with?locals_for_with.ctaUrl:typeof ctaUrl!=="undefined"?ctaUrl:undefined));;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./src/main/jade/templates/enrolment/enrolmentCtaButton.jade
// module id = /4E9
// module chunks = 14